<div class="card monsido-panel mt-3 mx-3">
  <div class="card-header">
    <h3 class="font-weight-300">Import Results</h3>
  </div>
  <div class="card-body">
    <p class="step-description">Here's a summary of the import operation.</p>

    @if (result) {
      <div class="results-summary">
        <div class="summary-header">
          <div class="summary-icon" [ngClass]="{
            'success': result.failed === 0,
            'warning': result.failed > 0 && result.successful > 0,
            'error': result.failed === result.total
          }">
            @if (result.failed === 0) {
              <i class="bi bi-check-circle-fill"></i>
            } @else if (result.successful > 0) {
              <i class="bi bi-exclamation-triangle-fill"></i>
            } @else {
              <i class="bi bi-x-circle-fill"></i>
            }
          </div>
          <div class="summary-title">
            @if (result.failed === 0) {
              All checks imported successfully!
            } @else if (result.successful > 0) {
              Import completed with some errors
            } @else {
              Import failed
            }
          </div>
        </div>

        <div class="summary-stats">
          <div class="stat-card">
            <div class="stat-label">Total Rows</div>
            <div class="stat-value">{{ result.total }}</div>
          </div>
          <div class="stat-card success">
            <div class="stat-label">Successful</div>
            <div class="stat-value">{{ result.successful }}</div>
          </div>
          <div class="stat-card error">
            <div class="stat-label">Failed</div>
            <div class="stat-value">{{ result.failed }}</div>
          </div>
          <div class="stat-card">
            <div class="stat-label">Success Rate</div>
            <div class="stat-value">{{ getSuccessRate() }}%</div>
          </div>
        </div>

        <div class="actions-section mt-4">
          <div class="d-flex gap-2">
            <button 
              type="button" 
              class="btn btn-primary"
              (click)="downloadDetailedReport()">
              <i class="bi bi-download"></i> Download Full Report (TXT)
            </button>
            @if (result.errors.length > 0) {
              <button 
                type="button" 
                class="btn btn-outline-secondary"
                (click)="downloadErrorReport()">
                <i class="bi bi-download"></i> Download Errors (CSV)
              </button>
            }
          </div>
        </div>

        @if (result.errors.length > 0) {
          <div class="errors-section">
            <div class="errors-header">
              <h6>Import Errors ({{ result.errors.length }})</h6>
            </div>

            <div class="errors-list">
              @for (error of result.errors; track error.rowNumber) {
                <div class="error-item">
                  <div class="error-row-number">Row {{ error.rowNumber }}</div>
                  <div class="error-check-id">Database ID: {{ error.id }}</div>
                  <div class="error-message">{{ error.error }}</div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
